import { defineFreeTextFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const titleDescriptor = defineFreeTextFilter({
  definition: {
    id: FilterId.TITLE,
    name: 'Titles',
    text: [],
    type: FilterType.FREE_TEXT,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_TITLE },
});
